export default "__VITE_ASSET__BBlgkKu___"